// extracted by mini-css-extract-plugin
module.exports = {"container":"CharacteristicsList_container__2GpSx"};